export default __webpack_public_path__ + "928495fae14841a0d61062ba4926be1d.svg";